import { render, staticRenderFns } from "./Hauwa.vue?vue&type=template&id=3ade7c9a&scoped=true&"
import script from "./Hauwa.vue?vue&type=script&lang=js&"
export * from "./Hauwa.vue?vue&type=script&lang=js&"
import style0 from "./Hauwa.vue?vue&type=style&index=0&id=3ade7c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade7c9a",
  null
  
)

export default component.exports